import {createSlice} from "@reduxjs/toolkit";

const initialUsersActionsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  pageCount: 0,
  entities: null,
  error: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const paypalRequestsSlice = createSlice({
  name: "paypalRequests",
  initialState: initialUsersActionsState,
  reducers: {
    paypalRequestsFetched: (state, action) => {
      const {totalCount, pageCount, entities} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.pageCount = pageCount;
    },
    paypalRequestsAppended: (state, action) => {
      const {totalCount, pageCount, entities} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = state.entities ? [...state.entities, ...entities] : [...entities];
      state.totalCount = totalCount;
      state.pageCount = pageCount;
    },
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.usersError = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
  }
});
